import s from './Reason.module.scss';
import { getSectionText } from '../data/sectionTexts';
import { reasons } from '../i18n/reason';
import { useLanguage } from '../contexts/LanguageContext';
import Title from '../Title/Title';

const ReasonIcon = ({ type }) => {
  if (type === 'private') {
    return (
      <svg viewBox="0 0 64 64">
        <rect x="18" y="27" width="28" height="23" rx="7" />
        <path d="M24 27v-6c0-5 3.5-9 8-9s8 4 8 9v6" />
        <path d="M32 38v5" />
        <circle cx="32" cy="36" r="2.5" />
      </svg>
    );
  }

  if (type === 'spot') {
    return (
      <svg viewBox="0 0 64 64">
        <circle cx="32" cy="32" r="10" />
        <path d="M32 8v8" />
        <path d="M32 48v8" />
        <path d="M8 32h8" />
        <path d="M48 32h8" />
        <path d="M15 15l6 6" />
        <path d="M43 43l6 6" />
        <path d="M49 15l-6 6" />
        <path d="M21 43l-6 6" />
        <circle cx="48" cy="14" r="2" />
        <circle cx="18" cy="20" r="1.5" />
      </svg>
    );
  }

  if (type === 'shuttle') {
    return (
      <svg viewBox="0 0 64 64">
        <rect x="13" y="21" width="38" height="22" rx="7" />
        <path d="M20 21l3-6h18l3 6" />
        <path d="M13 33h38" />
        <circle cx="23" cy="46" r="4" />
        <circle cx="41" cy="46" r="4" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 64 64">
      <rect x="14" y="23" width="36" height="25" rx="7" />
      <path d="M24 23l4-6h9l4 6" />
      <circle cx="32" cy="35" r="9" />
      <circle cx="44" cy="29" r="1.5" />
    </svg>
  );
};

const Reason = () => {
  const { lang } = useLanguage();
  console.log('Reason lang:', lang);

  const titleText = getSectionText(lang, 'reason');
  const reasonList = reasons[lang] || reasons.JP || [];

  return (
    <section className={s.root}>
      <Title kicker={titleText.kicker} title={titleText.title} />

      <div className={s.grid}>
        {reasonList.map((item) => (
          <article className={s.card} key={item.number}>
            <div className={s.cardHead}>
              <span className={s.number}>{item.number}</span>
              <p className={s.label}>{item.label}</p>
            </div>

            <div className={s.icon}>
              <ReasonIcon type={item.icon} />
            </div>

            <div className={s.content}>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Reason;
